import { render, staticRenderFns } from "./datosUser.vue?vue&type=template&id=1ffcae8a&scoped=true&"
import script from "./datosUser.vue?vue&type=script&lang=js&"
export * from "./datosUser.vue?vue&type=script&lang=js&"
import style0 from "./datosUser.vue?vue&type=style&index=0&id=1ffcae8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffcae8a",
  null
  
)

export default component.exports